import { PaginationEventData } from '../interface/pagination-event-data';

export class PaginationEvent {
  type: string;
  data: PaginationEventData;
}
